










import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import PocGLineChart from "@/shared/components/charts/PocGLineChart.vue";
import {
  InvestmentCustodian
} from "@/shared/types";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    PocGLineChart
  }
})
export default class InvestmentLineChart extends Vue {
  drivewealthStore = useDrivewealthStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();

  @Prop({ default: 220 })
  height: number;

  @Prop({ default: 6 })
  initialDisplayMonths: number;

  @Prop()
  displayMonthNames: boolean;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  get balancesLineChart () {
    return {
      classes: "balances-chart",
      width: 1064,
      height: this.height,
      hasHovers: false
    };
  }

  get selectedStartDate () {
    return moment().subtract((this.initialDisplayMonths), "months");
  }

  get isLoaded (): boolean {
    const apiCallResults = this.investmentDailyBalanceStore.investmentDataIsLoaded &&
        this.investmentDailyBalanceStore.hasDailyBalances;

    return apiCallResults;
  }

  selectedEndDate = moment();

  mounted () {
    this.investmentDailyBalanceStore.setCurrentEndDateKey(this.selectedEndDate.format("YYYYMMDD"));
    this.loadChartData();
  }

  loadChartData () {
    this.investmentDailyBalanceStore.loadDailyInvestmentBalances(this.loadDailyInvestmentBalancesArgs);
  }

  get loadDailyInvestmentBalancesArgs () {
    return {
      startDate: this.selectedStartDate.format("YYYY-MM-DD"),
      endDate: this.selectedEndDate.format("YYYY-MM-DD"),
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId,
      investmentCustodian: InvestmentCustodian.Drivewealth
    };
  }

  @Watch("loadDailyInvestmentBalancesArgs")
  reloadDailyBalancesChart () {
    this.loadChartData();
  }
}
